import Env from '../base/env';
import Component from 'gia/Component';
import gsap from 'gsap';
import { ScrollTrigger } from '../vendor/gsap-bonus-umd/ScrollTrigger';
import { SplitText } from "../vendor/gsap-bonus-umd/SplitText";
gsap.registerPlugin(ScrollTrigger,SplitText);

export default class Module extends Component
{
  constructor(element) {
    super(element);
    this.ref = {};
  }

  mount() {
    this.DOM = {}
    this.DOM.view = this.element
    //! Fx
    this.FX = {}
    this.FX.titleLines = new SplitText(this.ref.text, { type:'lines', linesClass:'lines tw-overflow-hidden',lineThreshold:.2 })
    this.FX.titleWords = new SplitText(this.ref.text, { type:'words' })
    //! Fns
    setTimeout(() => {
      this._fx()
    }, Env.timingDelayFx);
  }

  _fx()
  {
    this.animate()
    if(Env.mobileCSS == false) {
      this.makeSticky()
    }

  }

  animate()
  {
    this.animation = gsap.timeline({ scrollTrigger:{
        trigger:this.DOM.view,
        start:'top 45%',
        markers:false
      }
    })
    const posY = (Env.mobileCSS)?50:150;
    const DOM = {}
    DOM.searchVideo = this.DOM.view.querySelector('.fx-media-container')
    if(DOM.searchVideo != null) {
      DOM.container = DOM.searchVideo
      DOM.media = this.DOM.view.querySelectorAll('.fx-media')
    } else {
      DOM.container = this.DOM.view.querySelector('picture')
      DOM.media = this.DOM.view.querySelector('img')
    }

    this.animation.add([
      gsap.fromTo(
        DOM.container,
        {
          autoAlpha:0,
          y:posY
        },
        {
          autoAlpha:1,
          y:0,
          ease:'cubic.out',
          duration:1.5,

        }
      ),
    ])
    .add([
      gsap.fromTo(
        DOM.media,
        {
          scale:.92
        },
        {
          scale:1,
          ease:'quart.inOut',
          duration:1,

        }
      )
    ],'-=1.3')
    .add([
      gsap.fromTo(
        this.ref.flag,
        {
          autoAlpha:0
        },
        {
          autoAlpha:1,
          ease:'cubic.out',
          duration:.6
        }
      ),
      gsap.fromTo(
        this.FX.titleWords.words,
        {
          y:70
        },
        {
          y:0,
          stagger:.2,
          duration:.6,
          stagger:.05,
          ease:'quint.out'
        }
      ),
      gsap.fromTo(
        this.ref.cta,
        {
          autoAlpha:0,
          y:15
        },
        {
          autoAlpha:1,
          y:0,
          ease:'cubic.out',
          duration:.6,
          delay:.2
        }
      ),
    ])
  }

  makeSticky()
  {
    this.sticky = ScrollTrigger.create({
      trigger:this.DOM.view,
      start:'top top',
      end: ()=>{
        const viewport = Env.framework.toolbox.getViewport()
        return `+=${viewport.height}px`
      },
      pin:true,
      pinSpacing:false,
      invalidateOnRefresh: false,
    })
  }

  unmount()
  {
    this.sticky.kill(true)
  }
}
